function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mapStructToInstance } from '../hooks/styles';

function getDrawStyle(style, verticesStyle) {
  var renderStyle;
  var verticesStyles = verticesStyle ? [verticesStyle] : [];

  if (style) {
    try {
      renderStyle = style.Polygon || style.LineString || style.Point ? {
        Polygon: style.Polygon ? [mapStructToInstance(_objectSpread({
          zIndex: style === null || style === void 0 ? void 0 : style.zIndex
        }, style.Polygon)), ...verticesStyles] : undefined,
        LineString: style.LineString ? [mapStructToInstance(_objectSpread({
          zIndex: style === null || style === void 0 ? void 0 : style.zIndex
        }, style.LineString))] : undefined,
        Point: style.Point ? [mapStructToInstance(_objectSpread({
          zIndex: style === null || style === void 0 ? void 0 : style.zIndex
        }, style.Point))] : undefined
      } : undefined;
    } catch (e) {
      console.error(e);
    }
  }

  return renderStyle;
}

export default getDrawStyle;